// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import constants from "@store/constants";
import updateSearchFields from "@store/Framework/Store/Greif/Pages/ShipmentHistory/Handlers/UpdateSearchFields";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    return {
        parameter: state.greif.pages.shipmentHistory.getShipmentsParameter,
        session: getSession(state),
    };
};

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ShipmentHistorySearchFieldShowMyShipmentsStyles {
    select?: CheckboxProps;
    wrapper?: SearchFieldWrapperStyles;
}

export const showMyShipmentsStyles: ShipmentHistorySearchFieldShowMyShipmentsStyles = {};

const styles = showMyShipmentsStyles;

const ShipmentHistorySearchFieldShowMyShipments = ({ parameter: { isNextDaysFilter }, updateSearchFields }: Props) => {
    const handleChange = (checked: boolean) => {
        updateSearchFields({ isNextDaysFilter: checked ? true : undefined });
    };

    return (
        <SearchFieldWrapper extendedStyles={styles.wrapper}>
            <CheckboxGroup label={translate("Upcoming Shipments")}>
                <Checkbox
                    checked={isNextDaysFilter?.toString() === "true"}
                    onChange={(_, checked) => {
                        handleChange(checked);
                    }}
                >
                    {translate("Next 7 Days")}
                </Checkbox>
            </CheckboxGroup>
        </SearchFieldWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ShipmentHistorySearchFieldShowMyShipments),
    definition: {
        group: constants.widgetGroup.shipmentHistory,
        displayName: "Next 7 Days Only",
        allowedContexts: [constants.pageType.shipmentHistory],
    },
};

export default widgetModule;
